function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2.9a.9.9 0 100 1.8.9.9 0 000-1.8zm-1.8.9a1.8 1.8 0 111.515 1.778L8.692 5.593a1.8 1.8 0 01-2.85 2.19L3.597 8.903 3.6 9a1.8 1.8 0 11-.28-.963l2.12-1.06A1.8 1.8 0 018.005 4.99l1.079-1.777A1.797 1.797 0 018.4 1.8zM7.2 5.7a.9.9 0 100 1.8.9.9 0 000-1.8zM1.8 8.1a.9.9 0 100 1.8.9.9 0 000-1.8z"
});

function SvgAutomation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAutomation;